import urljoin from 'url-join'
import { SEARCH_URL } from '../../urls'
import { SiteQueryResult } from '@graphql/queries/__generated__/site.generated'

interface ISchemaPotentialAction {
  '@type': 'SearchAction'
  'query-input': string
  target: string
}

interface ISchemaWebSite {
  '@context': 'https://schema.org'
  '@type': 'WebSite'
  url: string
  description: string
  name: string
  potentialAction: ISchemaPotentialAction[] | ISchemaPotentialAction
}

export const structuredData = (site: SiteQueryResult['data']['siteSettings']) => {
  if (!site) return null
  const data: ISchemaWebSite = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    url: location.href,
    description: site.description,
    name: site.headerText,
    potentialAction: {
      '@type': 'SearchAction',
      'query-input': 'required name=search_term_string',
      target: urljoin(location.href, SEARCH_URL, '?q={search_term_string}'),
    },
  }
  return JSON.stringify(data)
}
